import React, {useMemo, useState } from "react";
import { Checkbox, Radio } from 'antd';
import { FilterOutlined } from '@ant-design/icons';

const SidebarFilter = ({group, annotationsNodeFilter, graph}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [version, setVersion] = useState(0);

  const handleTriggerClick = () => {
    setIsOpen((prev) => !prev);
  };

  const filteredItems = useMemo(() => {
    return annotationsNodeFilter.menuFilter().filter(item =>  item.group === group);
  }, [annotationsNodeFilter, group]);

  const onChange = (e, index) => {
    //console.log(`checked = ${e.target.checked}; index= ${index}`);
    annotationsNodeFilter.indexEnabled(index, e.target.checked);
    setVersion(prev => prev + 1);
    graph.update();
  };

  const onChangeRadio = (e, index) => {
    annotationsNodeFilter.indexEnabled(index, e.target.value);
    setVersion(prev => prev + 1);
    graph.update();
  };

  console.log("SidebarFilter.js", group, annotationsNodeFilter.menuFilter());  
  return (
    <span>
      <h3 
      className={`accordion-trigger noselect ${isOpen ? "accordion-trigger-active" : ""}`}
        id="selection-filter-trigger"
        style1={{ display: "block" }}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          textAlign: "left"
        }}
        onClick={handleTriggerClick}><span style={{ flex: 1, textAlign: "left" }}>{group}</span><FilterOutlined /></h3>
      <div className={`accordion-container ${isOpen ? "" : "hidden"}`} id="selection-filter" style={{"margin": "5px 10px"}}>
          {filteredItems.map((item, index) => (
            <div key={`${item.name}-${index}`}>
              {item.items
              ? 
               <Radio.Group value={annotationsNodeFilter.indexEnabled(item.index)} vertical onChange={e => onChangeRadio(e, item.index)}>
                  {item.items.map((itemRadio, indexRadio) => (
                    <Radio key={itemRadio.uri} value={itemRadio.uri}>{itemRadio.name}</Radio>
                  ))}
                </Radio.Group>
              :
                <Checkbox 
                  checked={annotationsNodeFilter.indexEnabled(item.index)} 
                  index={item.index}
                  onChange={e => onChange(e, item.index)}>{item.name}</Checkbox>
              }
            </div>
          ))}
      </div>
    </span>
  )
}

export default SidebarFilter